export const ADD_TO_ORDER = 'Add to Order';
export const SPECIAL_INSTRUCTION = 'Special Instructions';
export const PLEASE_COMPLETE_REQUIRED_SECTIONS_TO_CONTINUE = 'Please complete required sections to continue.';
